module.exports = __webpack_public_path__ + "static/img/nullBuyCar.0610f564.png";